import React from 'react';

import { Typography } from 'e100-react-components';
import { Box } from 'shared/components';

import { useFavouriteStations } from 'entities/stations';
import { useIntl } from 'react-intl';
import { useFilteredFavouriteStations } from '../../../../hooks';
import { useStyles } from './styles';

export const EmptyFilteredItemsMessage = () => {
  const { formatMessage } = useIntl();
  const favouriteStations = useFavouriteStations() || [];
  const filteredFavouriteStations = useFilteredFavouriteStations();
  const classes = useStyles();

  if (!(!filteredFavouriteStations.length && favouriteStations.length)) {
    return null;
  }

  return (
    <Box
      padding={{
        left: 2.75,
        right: 2.75
      }}
    >
      <Typography
        color="secondary"
        variant="subtitle2"
        classes={{
          root: classes.title
        }}
      >
        {formatMessage({ id: 'nothingWasFound' })}
      </Typography>
    </Box>
  );
};
